export default {
  label: 'Sentiment',
  placeholder: 'All',
  notClassified: 'Not Classified',
};
